import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Contact, ContactService } from '@fgb/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'fgb-opt-out',
  templateUrl: './opt-out.component.html',
  styleUrl: './opt-out.component.scss',
})
export class OptOutComponent implements OnInit, OnDestroy {
  contactUsForm: UntypedFormGroup;
  submitted = false;
  isChecked = false;
  sentSuccessfully: boolean = false;

  private readonly _subscription = new Subscription();

  constructor(private formBuilder: UntypedFormBuilder, private contactService: ContactService) {}

  get f() {
    return this.contactUsForm.controls;
  }

  ngOnInit() {
    this.initForm();
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }

  async submit(message: Contact, isValid: boolean) {
    this.submitted = true;
    if (isValid) {
      await this.contactService.sendMessage(message);
      this.sentSuccessfully = true;
    }
  }

  public initForm(): void {
    this.contactUsForm = this.formBuilder.group({
      category: ['Opt Out'],
      message: ['', [Validators.required, this.noWhitespaceValidator, this.invalidTagsValidator, this.profanityFilterValidator]],
    });

    this.watchMessage(this.contactUsForm);
  }

  public watchMessage(fg: UntypedFormGroup): void {
    this._subscription.add(
      fg?.get('message')?.valueChanges.subscribe((content: string) => {
        this.sentSuccessfully = false;
      })
    );
  }

  public noWhitespaceValidator(control: UntypedFormControl) {
    if (control.value === '') return;
    return control.value.trim().length ? null : { whitespace: true };
  }

  public invalidTagsValidator(control: UntypedFormControl) {
    if (control.value === '') return;
    var rgx = /<\/?script|<\/?a/gi;
    return rgx.test(control.value) ? { invalidTags: true } : null;
  }

  public profanityFilterValidator(control: UntypedFormControl) {
    if (control.value === '') return;
    //list of profanity words
    let profanityWords: string[] = [];
    //list of filtered profanity words
    let filteredProfanityWords: string[] = [];
    profanityWords.forEach((word) =>
      control.value.replace(/ /g, '').toLowerCase().includes(word.replace(/ /g, '').toLowerCase())
        ? filteredProfanityWords.push(word)
        : null
    );
    return filteredProfanityWords.length ? { profanityFilter: true } : null;
  }
}
